"use client";

import { FC } from "react";

import { useData } from "data/data-provider";

import RentalCarDatesRangeInput from "designs/Common/(car-search-form)/RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "designs/Common/(car-search-form)/RentalCarTimesRangeInput";
import DropOffLocationInput from "designs/Common/DropOffLocationInput";
import SearchButton from "designs/DesignB/components/SearchButton/SearchButton";
import LocationInput from "../../../Common/LocationInput";

export interface RentalCarSearchFormProps {}

const MobileSearch: FC<RentalCarSearchFormProps> = () => {
  const {
    setPickupLocation,
    setDropoffLocation,
    setSearchedPickupLocation,
    setSearchedDropoffLocation,
    pickupLocation,
    dropOffLocation,
    setDropoffLocationType,
    setSameDropoffLocation,
    dropoffLocationType,
    ourLocation,
  } = useData();

  const hasDropoffLocations = ourLocation.some(
    (loc) => loc.location_type === "drop_off" || loc.location_type === "both"
  );

  const renderRadioBtn = () => {
    return (
      <div className="flex items-center flex-wrap flex-row border-secondary-100 mb-4">
        <div className="grid grid-cols-2 gap-4 w-full bg-secondary-100 rounded-md">
          <div
            className={`p-0 md:p-2 flex items-center justify-center rounded-md cursor-pointer text-xs md:text-sm xl:text-lg leading-6  text-left m-1 ${
              dropoffLocationType === true
                ? "bg-primary-200 text-button-color shadow-black/10 opacity-100 font-bold"
                : " text-text-color"
            }`}
            onClick={(e) => {
              const currentLocation = pickupLocation ?? dropOffLocation;
              setDropoffLocationType(true);
              setSameDropoffLocation(true);
              setDropoffLocation(null);
              setSearchedDropoffLocation("");
              if (currentLocation) {
                setPickupLocation(currentLocation);
                setSearchedPickupLocation(currentLocation.name ?? "");
              }
            }}
          >
            Same Drop Off
          </div>
          <div
            className={`px-0 py-2 flex items-center justify-center rounded-md text-xs md:text-sm xl:text-lg leading-6 text-left cursor-pointer m-1 ${
              dropoffLocationType === false
                ? "bg-primary-200 text-button-color  shadow-black/10 font-bold "
                : "text-text-color"
            }`}
            onClick={() => {
              setDropoffLocationType(false);
              setSameDropoffLocation(false);
              const activeLocations = ourLocation.filter((loc) => loc.active !== false);
              if (activeLocations.length === 1) {
                setPickupLocation(activeLocations[0]);
                setDropoffLocation(activeLocations[0]);
                setSearchedPickupLocation(activeLocations[0].name ?? "");
                setSearchedDropoffLocation(activeLocations[0].name ?? "");
              } else {
                setPickupLocation(null);
                setDropoffLocation(null);
                setSearchedDropoffLocation("");
                setSearchedPickupLocation("");
              }
            }}
          >
            Different Drop Off
          </div>
        </div>
      </div>
    );
  };

  const isDdropOffdifferent = dropoffLocationType === false;

  return (
    <form className="w-full relative py-8 px-4 content-center items-center rounded-md shadow-xl bg-secondary-50/50 backdrop-blur-xl z-40">
      {hasDropoffLocations && renderRadioBtn()}
      <div
        className={`relative flex flex-col  ${
          isDdropOffdifferent ? "md:grid md:grid-cols-1 md:gap-2" : ""
        }`}
      >
        <div
          className={`${isDdropOffdifferent ? " " : "w-full my-2"}`}
          onClick={() => {
            if (window.innerWidth < 768) {
              window.scrollTo({
                top: 250,
                behavior: "smooth", // smooth animation
              });
            }
          }}
        >
          <LocationInput
            placeHolder="Pick Up Location"
            className="w-full  rounded-md"
            sameDropOffLocation={dropoffLocationType === false}
            searchBar={false}
          />
        </div>
        {isDdropOffdifferent && (
          <div
            className="my-2"
            onClick={() => {
              if (window.innerWidth < 768) {
                window.scrollTo({
                  top: 350,
                  behavior: "smooth", // smooth animation
                });
              }
            }}
          >
            <DropOffLocationInput
              placeHolder="Dropoff Location"
              className="w-full rounded-md"
              divHideVerticalLineClass="-inset-x-0.5"
            />
          </div>
        )}
      </div>
      <div className="relative flex flex-col">
        <RentalCarDatesRangeInput className="w-full rounded-md my-2" />

        <RentalCarTimesRangeInput
          dropOffLocationType={dropoffLocationType}
          className="w-full rounded-md my-2"
        />
      </div>
      <SearchButton />
    </form>
  );
};

export default MobileSearch;
